<div class="title">
    <div>{{ data && data.id ? 'Edit' : 'Add New' }} User</div>
    <div class="close rb rb-icon-close-circle" (click)="close()" data-cy="edit-user-dialog-close-btn">
    </div>
</div>
<div class="dialog-body">
    <form [formGroup]="userForm">
        <mat-form-field appearance="outline" class="form-field">
            <input matInput placeholder="First Name" formControlName="firstname" data-cy="user-firstname-input" />
            <mat-error
                *ngIf="userForm.get('firstname').errors && (userForm.get('firstname').touched || userForm.get('firstname').dirty)">
                Please enter a valid User First Name
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
            <input matInput placeholder="Last Name" formControlName="lastname" data-cy="user-lastname-input" />
            <mat-error
                *ngIf="userForm.get('lastname').errors && (userForm.get('lastname').touched || userForm.get('lastname').dirty)">
                Please enter a valid User Last Name
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
            <input matInput placeholder="Email Address" [readonly]="data && data.id" formControlName="email"
                data-cy="user-email-input" />
            <mat-error
                *ngIf="userForm.get('email').errors && (userForm.get('email').touched || userForm.get('email').dirty)">
                Please enter a valid email
            </mat-error>
        </mat-form-field>
        <app-role-selector (roleSelected)="handleRoleSelected($event)"
            [selectedRoleIds]="userForm.controls.roles.value" data-cy="edit-user-role-selector">
        </app-role-selector>
        <app-ex-user-access-selector [hidden]="!selectedRole || selectedRole.id === 1"
            [exUserAccessArr]="exUserAccessedSource" (selectedAccessChange)="onExUserAccessSourceChange($event)" data-cy="edit-user-ex-access-source-selector">
        </app-ex-user-access-selector>

        <div *ngIf="selectedRole && selectedRole.id !== 1 && selectedRole.id !== 4 " class="include-service-fee-wrapper"
            data-cy="standard-user-can-see-margin" (click)="toggleCanSeeMargin()">
            <i class="include-service-fee-btn active rb rb-icon-toggle-on" data-cy="standard-user-can-see-margin-active"
                *ngIf="canSeeMargin"></i>
            <i class="include-service-fee-btn inactive rb rb-icon-toggle-off" data-cy="standard-user-can-see-margin-inactive"
                *ngIf="!canSeeMargin"></i>
            <span style="font-size: 13px;">can see margin for fixed rate placement</span>
        </div>

        <div *ngIf="selectedRole && selectedRole.id === 4" class="include-service-fee-wrapper" data-cy="ex-user-include-service-fee"
            (click)="toggleIncludeServiceFee()">
            <i class="include-service-fee-btn active rb rb-icon-toggle-on" data-cy="ex-user-include-service-fee-active" *ngIf="includeServiceFee"></i>
            <i class="include-service-fee-btn inactive rb rb-icon-toggle-off" data-cy="ex-user-include-service-fee-inactive" *ngIf="!includeServiceFee"></i>
            <span style="font-size: 13px;">Include service fees in cost related metrics</span>
        </div>

    </form>
    <button mat-raised-button class="rubii-btn add-btn" color="primary" data-cy="user-edit-dialog-save-btn"
        (click)="save($event)" style="margin-top: 30px;">
        Save
    </button>
</div>